var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14h11M7 19h6M7 24.015h4M13 31.015H3a2 2 0 01-2-2v-21a2 2 0 012-2h5a5 5 0 0110 0h5a2 2 0 012 2v3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.015a.5.5 0 110 1 .5.5 0 010-1M20 30.382h4.002M22.001 30.382V24.62",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.149 19.678a.466.466 0 00.108-.523.5.5 0 00-.462-.297h-9.589a.5.5 0 00-.462.297.466.466 0 00.109.523L22 24.62l5.148-4.942z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.052 18.859a2.342 2.342 0 01-.05-.48c.001-1.08.753-2.026 1.837-2.312 1.084-.285 2.234.159 2.81 1.086.574.928.434 2.11-.345 2.889a2.576 2.576 0 01-2.991.449",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBarReport;